import { stringify } from 'qs'

export const loginPath = args => {
  const path = '/login'

  if (args && args.query) {
    const query = stringify(args.query)
    return `${path}?${query}`
  }

  return path
}

export const logoutPath = () => '/logout'

export const signupPath = args => {
  const path = '/signup'

  if (args && args.query) {
    const query = stringify(args.query)
    return `${path}?${query}`
  }

  return path
}

export const forgotPath = () => '/forgot'
export const enablePath = () => '/enable'

export const startupProgramPath = args => {
  const path = `/startup-program`

  if (args && args.query) {
    const query = stringify(args.query)
    return `${path}?${query}`
  }

  return path
}
